export default __webpack_public_path__ + "static/media/quick_start_logo.4dde564a.svg";